import Vue from "vue";
import Vuex from "vuex";
import route from "./router.js";
import axios from "axios";

Vue.use(Vuex);

let store = new Vuex.Store({
  state: {
    token: localStorage.getItem("token") || "",
    messageTitle: "",
    messageContent: "",
    messageType: "",
    messageHtml: false,
    messageBoxVisible: false,
    bidModalVisible: false,
    autobidModalVisible: false,
    auctionEditVisible: false,
    role: "",
    userId: "",
    name: "",
    activeAuction: null,
    activeBid: null,
    activeVesselName: "",
    auctionFromSeabay: false,
    auctionTimePassed: null,
    latestBidMessageId: "",
    activeBids: [],
    auctionExtended30: 0,
    auctionExtended2min: 0,
    showLoader: false,
    loaderText: "",
    isNavExpanded: true,
    isMobile: false,
    isSmallScreen: false,
    navbarExpandedOverlay: false,
    activeNav: "",
    unsavedSettingChanges: false,
    multiVesselDealVisible: false,
    windowWidth: null,
    windowHeight: null,
    availableRequirements: [],
    redirectToAuctionOnLogin: "",
    auctionToBeCreatedOnLogin: "",
    auctionTriggerShown: false,
    changePasswordShown: false,
    resetPasswordShown: false,
    fuelPriceModalShown: false,
    fuelPrice: null,
    fuelUnit: null,
    showNewMessage: false,
  },
  mutations: {
    clearToken(state) {
      localStorage.removeItem("token");
      state.token = "";
      state.userId = null;
      state.role = null;
      state.name = null;
    },
    setToken(state, val) {
      state.token = val;
    },
    setMessage(state, val) {
      state.messageTitle = val.title;
      state.messageType = val.type;
      state.messageContent = val.content;
      state.messageHtml = val.html;
      state.messageBoxVisible = true;
    },
    clearMessage(state, val) {
      state.messageTitle = "";
      state.messageType = "";
      state.messageContent = "";
      state.messageBoxVisible = false;
    },
    setUserData(state, val) {
      state.userId = val.id;
      state.role = val.role;
      state.name = val.name;
    },
    setFuelPriceData(state, val) {
      state.fuelPrice = val.fuelPrice;
      state.fuelUnit = val.fuelUnit;
      store.dispatch("getRequest", {
        controller: "auction",
        method: `SetFuelCost/${state.activeAuction.id}`,
        parameters: {
          rate: state.fuelPrice,
          unit: state.fuelUnit,
        },
      });
    },
    setActiveAuction(state, val) {
      state.activeAuction = val;
      state.fuelPrice = val.fuelCost;
      state.fuelUnit = val.fuelUnit;
    },
    setActiveBid(state, val) {
      state.activeBid = val;
    },
    setNewMessage(state, val) {
      state.showNewMessage = val;
    },
    setActiveVesselName(state, val) {
      state.activeVesselName = val;
    },
    setBidModalVisible(state, val) {
      state.bidModalVisible = val;
    },
    setAutoBidModalVisible(state, val) {
      state.autobidModalVisible = val;
    },
    setAuctionEditVisible(state, val) {
      state.auctionEditVisible = val;
    },
    setCreate(state, val) {
      state.auctionFromSeabay = val;
    },
    setTimePassed(state, val) {
      state.auctionTimePassed = val;
    },
    setNewBidMessage(state, val) {
      state.latestBidMessageId = val;
    },
    setAuctionExtend(state, val) {
      if (val == 30) {
        state.auctionExtended30++;
      } else {
        state.auctionExtended2min++;
      }
    },
    setLoadingAnimation(state, val) {
      state.showLoader = val.show;
      state.loaderText = val.text;
    },
    hideLoadingAnimation(state) {
      state.showLoader = false;
      state.loaderText = "";
    },
    toggleNav(state, val) {
      state.isNavExpanded = val;
    },
    setIsMobile(state, val) {
      state.isMobile = val;
    },
    setActiveNav: function(state, val) {
      state.activeNav = val;
    },
    setSettingsSaveStatus: function(state, val) {
      state.unsavedSettingChanges = val;
    },
    setMultiVesselDealVisible: function(state, val) {
      state.multiVesselDealVisible = val;
    },
    setAvailableRequirements: function(state, val) {
      state.availableRequirements = val;
    },
    setWindowSize(state, val) {
      state.windowWidth = val.width;
      state.windowHeight = val.height;
      if (state.windowWidth < 600 || state.windowHeight < 600) {
        state.isMobile = true;
      } else {
        state.isMobile = false;
      }
      if (state.windowWidth < 992) {
        state.isSmallScreen = true;
      } else {
        state.isSmallScreen = false;
      }
      if (state.windowWidth < 1410) {
        state.navbarExpandedOverlay = true;
      } else {
        state.navbarExpandedOverlay = false;
      }
      if (state.isNavExpanded && state.navbarExpandedOverlay) {
        state.isNavExpanded = false;
      }
    },
    setRedirectOnLogin(state, val) {
      state.redirectToAuctionOnLogin = val;
    },
    setAuctionToBeCreated(state, val) {
      state.auctionToBeCreatedOnLogin = val;
    },
    toggleAuctionTriggerModal(state, val) {
      state.auctionTriggerShown = val;
    },
    toggleChangePasswordModal(state, val) {
      state.changePasswordShown = val;
    },
    toggleResetPasswordModal(state, val) {
      state.resetPasswordShown = val;
    },
    toggleFuelPriceModal(state, val) {
      state.fuelPriceModalShown = val;
    },
  },
  actions: {
    async getRequest({ commit }, data) {
      var url = data.method ? `/${data.controller}/${data.method}` : `/${data.controller}`;
      if (data.parameters) {
        url += "?";
        for (var key in data.parameters) {
          if (data.parameters.hasOwnProperty(key)) {
            url += `${key}=${data.parameters[key]}&`;
          }
        }
      }

      let response = await axios
        .get(url)
        .then(function(response) {
          return response.data;
        })
        .catch((e) => {
          if (e.status == 401) {
            return store.dispatch("onNotAuthenticated");
          } else {
            return false;
          }
        });
      return response;
    },
    async postRequest({ commit }, data) {
      var url = `/${data.controller}/${data.method}`;

      let response = await axios
        .post(url, data.parameters)
        .then(function(response) {
          if (response.data) {
            return response.data;
          } else {
            return true;
          }
        })
        .catch((e) => {
          if (e.status == 401) {
            return store.dispatch("onNotAuthenticated");
          } else {
            return false;
          }
        });
      return response;
    },
    async tokenLogin({ commit }) {
      store.commit("setLoadingAnimation", {
        show: true,
        text: "Logging in",
      });
      this.isSettingPassword = false;
      var self = this;
      var url = `${process.env.VUE_APP_API_URL}/sso/login?token=${route.currentRoute.query.token}`;

      axios
        .post(url)
        .then(function(response) {
          store.commit("hideLoadingAnimation");
          if (response.data.id && response.data.role && response.data.name) {
            commit("setUserData", {
              id: response.data.id,
              role: response.data.role,
              name: response.data.name,
            });
            route.push("/dashboard");
          } else {
            commit("clearToken");
            route.push("/login");
          }
        })
        .catch(function(error) {
          commit("clearToken");
          route.push("/login");
        });
    },
    async deleteRequest({ commit }, data) {
      var url = data.method
        ? `${process.env.VUE_APP_API_URL}/${data.controller}/${data.method}`
        : `${process.env.VUE_APP_API_URL}/${data.controller}`;
      if (data.parameters) {
        url += "?";
        for (var key in data.parameters) {
          if (data.parameters.hasOwnProperty(key)) {
            url += `${key}=${data.parameters[key]}&`;
          }
        }
      }

      let response = await axios
        .delete(url)
        .then(function(response) {
          return response.data;
        })
        .catch(() => {
          return false;
        });
      return response;
    },
    async login({ commit }, data) {
      var baseUrl = process.env.VUE_APP_API_URL;
      var formData = new FormData();
      formData.append("email", data.email);
      formData.append("password", data.password);
      store.commit("setLoadingAnimation", {
        show: true,
        text: "Logging in",
      });
      let response = await axios.post(`${baseUrl}/login/attempt`, formData).catch(() => {
        commit("clearToken");
        commit("setMessage", {
          title: "Unable to Login",
          type: "error",
          content: "An account was not found with that username and password.",
        });
        store.commit("hideLoadingAnimation");
        return false;
      });

      if (response) {
        store.commit("hideLoadingAnimation");
        route.push("/dashboard");
      }
    },
    async onNotAuthenticated({ commit }, redirect = true) {
      commit("clearToken");
      store.commit("hideLoadingAnimation");
      if (redirect) {
        route.push({
          name: "login",
          params: {
            redirect: true,
          },
        });
      }

      return false;
    },
    async authenticate({ commit }, redirect = true) {
      var baseUrl = process.env.VUE_APP_API_URL;
      return await axios
        .get(`${baseUrl}/login/authenticate`)
        .then(function(response) {
          if (response.data.id && response.data.role && response.data.name) {
            store.commit("hideLoadingAnimation");
            commit("setUserData", {
              id: response.data.id,
              role: response.data.role,
              name: response.data.name,
            });
            return true;
          } else {
            return store.dispatch("onNotAuthenticated", redirect);
          }
        })
        .catch(() => {
          return store.dispatch("onNotAuthenticated");
        });
    },
    async logout({ commit }) {
      var baseUrl = process.env.VUE_APP_API_URL;

      let response = await axios.get(`${baseUrl}/login/logout`).catch(() => {
        commit("clearToken");
        return false;
      });
      return true;
    },
    async setBidAmount({ commit }, value) {
      var self = this;
      var baseUrl = process.env.VUE_APP_API_URL;
      var formData = new FormData();
      formData.append("auctionId", self.state.activeAuction.id);
      formData.append("offerId", self.state.activeBid.offerId);
      formData.append("newBidAmount", value);
      let response = await axios.post(`${baseUrl}/auction/SetBidAmount`, formData).catch(() => {
        return false;
      });
      self.state.activeBid.currentRate = value;
      return true;
    },
  },
  getters: {},
});
export default store;
